export default __webpack_public_path__ + "static/media/homepage_module_comments.4413eed2.png";